export default class breakpointChecker {
  constructor(props) {
    this.breakpoint = window.matchMedia(props.mediaQuery)
    this.onMatchBP = props.onMatch
    this.onDifferentBP = props.onDifferent
    this.breakpoint.addListener(this.breakpointChecker.bind(this))
    // kickstart
    this.breakpointChecker()
  }
  breakpointChecker() {
    // if larger viewport and multi-row layout needed
    if (this.breakpoint.matches === true) {
      // clean up old instances and inline styles when available
      this.onMatchBP()
      // or/and do nothing
      return;
      // else if a small viewport and single column layout needed
    } else if (this.breakpoint.matches === false) {
      // fire small viewport version of swiper
      return this.onDifferentBP()
    }
  }
}